import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Carousel from "../../components/Carousel";
import { Badge, Col, Container, Row } from "reactstrap";
import ShowcaseCard from "./ShowcaseCard";
import "../../assets/styles/ProgramCarousel.scss";

const ProgramsCarousel = (prop) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 3,
    pauseOnHover: true,
    className: "center",
    rows: 2,
  };

  const topPrograms = prop.topPrograms;
  return (
    // <Container className="pl-5 pr-5">
    <Carousel settings={settings}>
      {topPrograms.map((program, index) => (
        <React.Fragment>
          <Col key={index} id={index}>
            <ShowcaseCard
              title={program.title}
              category={program.category}
              description={program.description}
              tags={program.tags}
              labels={program.labels ? program.labels : []}
              buttonText={program.buttonText}
              img={program.img}
              targetPath={program.targetPath}
            />
          </Col>
        </React.Fragment>
      ))}
    </Carousel>
    // </Container>
  );
};

export default ProgramsCarousel;
